// extracted by mini-css-extract-plugin
export default {"departments":"dG-z","departmentHeading":"eG-z","departmentSection":"fG-z","departmentName":"gG-z","departmentLink":"hG-z","expandIcon":"iG-z"};